import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Toggle } from '@/components/ui/toggle';

/**
 * 機能フラグの編集。
 *
 * 生の JSON を書かせない。キーは自由だが値は真偽値だけなので、
 * 一覧 + トグル + 追加欄で足りる。
 */
export function FeatureFlagEditor({
  flags,
  onChange,
  disabled,
}: {
  flags: Record<string, boolean>;
  onChange: (next: Record<string, boolean>) => void;
  disabled?: boolean;
}) {
  const [newKey, setNewKey] = useState('');
  const entries = Object.entries(flags).sort(([a], [b]) => a.localeCompare(b));

  function add() {
    const key = newKey.trim();
    if (!key) return;
    onChange({ ...flags, [key]: true });
    setNewKey('');
  }

  return (
    <div className="flex flex-col gap-3">
      {entries.length === 0 ? (
        <span className="text-xs text-ink-subtle">フラグはありません。</span>
      ) : (
        <div className="flex flex-col gap-2">
          {entries.map(([key, enabled]) => (
            <div key={key} className="flex items-center gap-3">
              <Toggle
                checked={enabled}
                label={key}
                disabled={disabled}
                onChange={(next) => onChange({ ...flags, [key]: next })}
              />
              <span className="flex-1 font-mono text-xs text-ink-secondary">{key}</span>
              <Button
                variant="ghost"
                disabled={disabled}
                onClick={() => {
                  const next = { ...flags };
                  delete next[key];
                  onChange(next);
                }}
              >
                削除
              </Button>
            </div>
          ))}
        </div>
      )}

      <div className="flex gap-2">
        <Input
          value={newKey}
          onChange={(e) => setNewKey(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add();
            }
          }}
          placeholder="フラグ名（例: reportsV2）"
          className="flex-1 font-mono text-xs"
          disabled={disabled}
        />
        <Button onClick={add} disabled={disabled || newKey.trim() === ''}>
          追加
        </Button>
      </div>
    </div>
  );
}
